import React from "react";
import first from "../assets/629535d5008792598b41bf76.png";
import second from "../assets/62953512d1c9ec38de3b665c.png";
import third from "../assets/Photoviewr- Search for any photos.png";
import fourth from "../assets/React App.png";
import fifth from "../assets/xchangefx-netlify-app-1024x768desktop-9a5e32.jpg";
import "../Content/css/Projects.css";

const Projects = () => {
  return (
    <div className="proj" id="proj">
      <h2>My development Projects</h2>
      <p className="jaz">Below are some of my projects:</p>
      <div className="praw">
        <div className="mincard">
          <div className="reimg">
            <img src={first} alt="" />
          </div>
          <div className="retext">
            This is a random advice app. It randomly generates different advices
            on clicking the shiny green button.{" "}
            <a
              className="check"
              href="https://writtenadvice.netlify.app"
              target="_blank"
            >
              Written Advice
            </a>
          </div>
        </div>
        <div className="mincard">
          <div className="reimg">
            <img src={second} alt="" />
          </div>
          <div className="retext">
            This is an ecommerce project I worked on which features different
            products and payments, check outs.{" "}
            <a
              href="https://shopafrica.netlify.app"
              className="check"
              target="_blank"
            >
              Shop Africa
            </a>
          </div>
        </div>
        <div className="mincard">
          <div className="reimg">
            <img src={third} alt="" />
          </div>
          <div className="retext">
            This is a photo app project. It features any type of photos useful
            for wallpapers, fun, projects. It cuts across.{" "}
            <a
              href="https://photoviewr.netlify.app"
              className="check"
              target="_blank"
            >
              Photoviewr
            </a>
          </div>
        </div>
        <div className="mincard">
          <div className="reimg">
            <img src={fourth} alt="" />
          </div>
          <div className="retext">
            This is a resume vetter. I created it as a result of common problems
            like people not being able to properly create their resume and
            people that needed to vet their resume.{" "}
            <a
              target="_blank"
              href="https://resm.netlify.app"
              className="check"
            >
              RESM
            </a>
          </div>
        </div>
        <div className="mincard">
          <div className="reimg">
            <img src={fifth} alt="" />
          </div>
          <div className="retext">
            This is a currency converter for checking conversion rates in real
            time.{" "}
            <a
              target="_blank"
              href="https://xchangefx.netlify.app"
              className="check"
            >
              XchangeFX
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
